// extracted by mini-css-extract-plugin
module.exports = {"input":"Steps_input__1dPMg","inputWrap":"Steps_inputWrap__24LkN","checkboxes":"Steps_checkboxes__2TAjL","wrap":"Steps_wrap__3yMHD","btn":"Steps_btn__Pg60D"};